/**
 * Human-readable error toasts for every failure path. [P6-polish]
 */

export type ToastKind = 'error' | 'info';

export class Toaster {
  constructor(private readonly container: HTMLElement) {}

  show(message: string, kind: ToastKind = 'info', durationMs = 3600): void {
    const el = document.createElement('div');
    el.className = `toast ${kind}`;
    el.textContent = message;
    el.setAttribute('role', kind === 'error' ? 'alert' : 'status');
    this.container.appendChild(el);
    window.setTimeout(() => {
      el.style.transition = 'opacity 0.25s ease';
      el.style.opacity = '0';
      window.setTimeout(() => el.remove(), 260);
    }, durationMs);
  }

  error(message: string): void {
    this.show(message, 'error');
  }

  info(message: string): void {
    this.show(message, 'info');
  }
}
